/*
 * @Author: your name
 * @Date: 2020-06-16 09:39:43
 * @LastEditTime: 2020-07-30 15:52:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xcxpc\src\components\libs\permission\permission.js
 */
import router from '@/router'
import NProgress from 'nprogress' // Progress 进度条
import './nprogress.css'// Progress 进度条样式



// 会进入两边，因为需要加auth
router.beforeEach((to, from, next) => {

// // 一些身份不需要显示文字
  let justSelectBook =  JSON.parse(window.LS.get("taxHeader")||'{}')
  let isMine = justSelectBook.isMy==1
  if( to.meta.store && !isMine)to.meta.taxNoShow = true
// end

  let auth =  JSON.parse(window.LS.get("SY") || "{}")
  let authPK = auth.userInfo?auth.userInfo.pkUser:""
  if(!to.query.auth && !!authPK){ //没有Auth
    next({path:to.fullPath,query:Object.assign(to.query,{auth:authPK})})
    return
  }
  if(!!to.query.auth && !!authPK){
    //有Auth,比对是否一样
    if(to.path == '/NoAuth'){
      next()
    } else{
      // 有时候不需要进度圈
      if(to.path == from.path && JSON.stringify(to.query) == JSON.stringify(from.query)){
      }else{
        NProgress.start();
      }
      (to.query.auth==authPK && !!authPK)?next():next({path:'/NoAuth'})
      return
    }
  }

  if(!authPK){
    next()
  }
})

router.afterEach((to,from) => {
  NProgress.done() // 结束Progress
})
